<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Total Pagos Procesados"
              :value="numFacturas"
              description="<span
                class='text-sm font-weight-bolder text-success'
                > "
              :icon="{
                component: 'ni ni-bullet-list-67',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Pagos Correctos"
              :value="numFacturasOk"
              description="<span
                class='text-sm font-weight-bolder text-success'
                > "
              :icon="{
                component: 'ni ni-check-bold',
                background: 'bg-gradient-success',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <mini-statistics-card
              title="Pagos con Error"
              :value="numFacturasError"
              description="<span
                class='text-sm font-weight-bolder text-success'
                > "
              :icon="{
                component: 'ni ni-fat-remove',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle',
              }"
            />
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>
<script setup>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";

</script>

<script>
import facturacion from "../api/pagos";
export default {
  created() {
    this.getStatics();
  },
  data() {
    return {
      
      model:{
        token: localStorage.getItem("token"),
      },
      numFacturas: 1,
      numFacturasOk: 1,
      numFacturasError: 1,
    };
  },
  methods: {
    getStatics() {
      this.model.token=localStorage.getItem("token")
      facturacion
        .getStatics(this.model)
        .then((result) => {
          const data = result.data || result; 
          console.log("Datos recibidos:", data);
    // Mapeo de variables (ajustado a los nombres del JSON: numtotal, numOk, numError)
          this.numFacturas = data.numtotal ?? 0;
          this.numFacturasOk = data.numOk ?? 0;
          this.numFacturasError = data.numError ?? 0;
        })
        .catch((err) => {
          console.log(err)
          this.numFacturas = 0
          this.numFacturasOk = 0
          this.numFacturasError= 0
        });

    }
   
  },
};
</script>
